export default __webpack_public_path__ + "static/media/mail_sent.e0685cac.svg";